import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { MirIcon } from '@widgets/mir-icon';
import { PromptDialogComponent } from './prompt-dialog.component';
import { PromptDialogService } from './services/prompt-dialog.service';

const PUBLIC = [
  PromptDialogComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MirIcon,
  ],
  providers: [
    PromptDialogService
  ],
  declarations: PUBLIC,
  exports: PUBLIC
})
export class PromptDialogModule { }
